import { defineComponent as _defineComponent } from 'vue'
import { watch, ref } from "vue";
import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputDate',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;
const { onInput } = setup(emit);
const hidePlacheHolder = ref(false);
watch(props, (props) => {
  if (props.modelValue !== null) {
    if (("" + props.modelValue).length > 0) {
      hidePlacheHolder.value = false;
    }
  }
});

const __returned__ = { props, emit, onInput, hidePlacheHolder }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})